var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-image-gallery-item"},[_c('ButtonCircle',{staticClass:"modal-image-gallery-item_button",attrs:{"text":"Visa bild i full storlek","variant":"dark"},on:{"click":function () { return _vm.openModalOnClick(this$1); }}},[_c('IconExpand')],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }